import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPropertyType } from "reduxStore/action/masterActions";
import {
  getAllProperty,
  getPropertyFilterList,
  propertyStatusUpdate,
  getAgentProperty
} from "reduxStore/action/propertyActions";
import TableDataNotFound from "component/TableDataNotFound";
import strings from "translate/language";
import { handleListResponse, seo } from "utils/utils";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import Select from "react-select";
// import { syncAllProjects } from "../../reduxStore/action/propertyActions";
import { handleDetailResponse } from "utils/utils"

const Property = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [apiResponse, setApiResponse] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const propertySelector = useSelector((state) => state.propertyData) || {};
  const ReportListSelector = useSelector((state) => state.report);
  const { create, view, edit,isAdmin } = usePermission({
    create: "add_property",
    view: "view_property",
    edit: "edit_property",
  });

  const user_id = useSelector((state) => {
    const { response } = state.login;
    return handleDetailResponse(response.data)._id
  });

  const role_id = useSelector((state) => {
    const { response } = state.login;
    return handleDetailResponse(response.data).role_id
  });

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    location: "",
    property_name: "",
    property_type: "",
  });

  const [handleStatus, setHandleStatus] = useState({});
  const [searchData, setSearchData] = useState([]);

  const { response } = propertySelector;

  const propertyTypesSelector = useSelector((state) => state.propertyTypes);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    if(isAdmin){
    const { reportPropertyList } = ReportListSelector;
    if (reportPropertyList) {
      if (reportPropertyList?.status === 200) {
        setPropertyList(handleListResponse(reportPropertyList.data));
      } else {
        setPropertyList([]);
      }
    }
  }
  }, [ReportListSelector]);

  useEffect(() => {
    if (propertyTypesSelector?.response) {
      const { response } = propertyTypesSelector;
      if (response?.status === 200) {
        setSearchData(response.data);
      } else {
        setSearchData([]);
      }
    }
  }, [propertyTypesSelector]);

  useEffect(() => {
    dispatch(getPropertyType());
    if(isAdmin){
      dispatch(getAllProperty({ offset: page, limit: 10 }));
    }else{
      dispatch(getAgentProperty({ offset: page, limit: 10 }));
    }
    
  }, [dispatch]);

  useEffect(() => {
    if (propertySelector.create) {
      if (response?.status === 200) {
        if (handleStatus.property_id) {
          if(isAdmin){
            dispatch(getAllProperty({ limit: 10, offset: page }));
          }else{
            dispatch(getAgentProperty({ limit: 10, offset: page }));
          }
          
        }
        setHandleStatus({});
      } else {
      }
    } else {
      if (response && response.status === 200) {
        setApiResponse(handleListResponse(response?.data));
        setPropertyList(handleListResponse(response?.data));
      } else {
        setApiResponse([]);
      }
    }
  }, [dispatch, propertySelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getPropertyFilterList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          location: form.location,
          property_name: form?.site?.property_title,
          property_type: form.property_type,
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      location: "",
      property_name: "",
      property_type: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    if(isAdmin){
      dispatch(getAllProperty({ limit: 10, offset: 0 }));
    }else{
      dispatch(getAgentProperty({ limit: 10, offset: 0 }));
    }
    
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleUserStatus = () => {
    dispatch(propertyStatusUpdate(handleStatus));
  };

  useEffect(() => {
    if(isAdmin){
      dispatch(getReportPropertyList({ limit: 10, offset: 0, user_id, role_id }));
    }
    
  }, [dispatch]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    let params = {
      limit: 10,
      offset: newOffset,
      start_date: form.start_date,
      end_date: form.end_date,
      location: form.location,
      property_name: form?.site?.property_title,
      property_type: form.property_type,
    };
    if(isAdmin){
      dispatch(getAllProperty(params));
    }else{
      dispatch(getAgentProperty(params));
    }
    
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Property Listing",
      metaDescription: "All registered property list",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabe2">
                {handleStatus.status
                  ? strings.activeProperty
                  : strings.deactiveProperty}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6>{strings.areYouSure}</h6>
              </div>
              <div className="text-center">
                <h6>
                  {" "}
                  {handleStatus.status
                    ? strings.activeThisProperty
                    : strings.deactiveThisProp}
                </h6>
              </div>
            </div>
            <div className="modal-footer justify-content-center ">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleUserStatus()}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
      <Breadcrumb
        title={strings.Property}
        titleactive={strings.propertyListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              // data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchBylocality}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              placeholder={strings.searchlocality}
                              type="text"
                              autoComplete="off"
                              name="location"
                              value={form.location}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4  ">
                          <span className="cardText">
                            {strings.searchByProjectName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (isAdmin) {
                                // Use getAgentProperty if isAdmin is true
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    })
                                  );
                                }
                                
                              } else {
                                // Default behavior: use getReportPropertyList
                               
                                if (e.length > 1) {
                                  dispatch(
                                    getAgentProperty({
                                      search_site: e,
                                      isLoadMore: true,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getAgentProperty({
                                      limit: "",
                                      offset: 0,
                                      isLoadMore: true,
                                    })
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByProjectName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="exampleFormControlSelect9"
                            name="property_type"
                            value={form.property_type}
                            onChange={(event) => handleInputField(event)}
                          >
                            <option defaultValue={null}>
                              {strings.selectstatus}
                            </option>
                            <option value={"1"}>{strings.active}</option>
                            <option value={"2"}>{strings.deactive}</option>
                            {/* {searchData.length > 0 ? (
                              searchData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )} */}
                          </select>
                        </div>
                        <div className="col-md-4 pt-4 d-flex justify-content-end">
                          <div className="form-group">
                            <Button
                              className="btn btn-warning  mr-4"
                              onClick={filterDetail}
                              label={strings.search}
                            ></Button>
                            <Button
                              className="btn btn-dark"
                              onClick={filterReset}
                              label={strings.reset}
                            ></Button>
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    {/* <Button
                      onClick={() => navigatpage("/addnewproperty")}
                      label={strings.addNewProperty}
                    ></Button> */}
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <div className="form-group" style={{ float: "right" }}>
                    <Button
                      label={strings.syncAllProperty}
                      onClick={() => {
                        dispatch(syncAllProjects());
                      }}
                    ></Button>
                  </div>
                </div> */}
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.propertyList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.projectName}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.vistior}</th>
                          <th scope="col">{strings.sitevisit}</th>
                          <th scope="col">{strings.bookingVisit}</th>
                          <th scope="col">{strings.closeVisit}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.budget}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {apiResponse &&
                          apiResponse.map((item, index) => (
                            <tr key={index} className="text-center">
                              <td
                                className="transform"
                                style={{ inlineSize: "130px" }}
                              >
                                {item.property_title}
                              </td>
                              <td>
                                {moment(item.createdDate).format(
                                  "DD-MM-yyyy hh:mm a"
                                )}
                              </td>
                              <td>{item.total_visitor}</td>
                              <td>{item.site_visit}</td>
                              <td>{item.booking_visit}</td>
                              <td>{item.close_visit}</td>
                              <td
                                style={{
                                  color: item.status ? "green" : "red",
                                  fontWeight: item.status ? "500" : "500",
                                }}
                              >
                                {item.status ? "Active" : "Deactive"}
                              </td>
                              <td>
                                {item?.min_rate}
                                {item.min_rate ? item.min_rate_type : null}
                                {" - "}
                                {item?.max_rate}
                                {item.max_rate ? item.max_rate_type : null}
                              </td>
                              <td className="p-2">
                                {view && (
                                  <i
                                    className="fa fa-eye theme-fa-icon p-2"
                                    aria-hidden="true"
                                    title={strings.viewProperty}
                                    onClick={() => {
                                      navigatpage("/viewproperty/" + item._id);
                                    }}
                                  ></i>
                                )}

                                {edit && item?.status !== false && (
                                  <i
                                    className="fa fa-edit theme-fa-icon"
                                    aria-hidden="true"
                                    title={strings.editProperty}
                                    onClick={() => {
                                      navigatpage("/editproperty/" + item._id);
                                    }}
                                  ></i>
                                )}
                                {/* {edit &&
                                  (item.status ? (
                                    <i
                                      className="fa fa-ban theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.deactiveProperty}
                                      data-toggle="modal"
                                      data-original-title="test"
                                      data-target="#exampleModal1"
                                      onClick={() =>
                                        setHandleStatus({
                                          property_id: item._id,
                                          status: false,
                                        })
                                      }
                                    ></i>
                                  ) : (
                                    <i
                                      className="fa fa-unlock theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.activeProperty}
                                      data-toggle="modal"
                                      data-original-title="test"
                                      data-target="#exampleModal1"
                                      onClick={() =>
                                        setHandleStatus({
                                          property_id: item._id,
                                          status: true,
                                        })
                                      }
                                    ></i>
                                  ))} */}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <TableDataNotFound data={apiResponse} />
                  </div>
                  <Pagination
                    totalCount={propertySelector?.response?.total_data}
                    listData={apiResponse}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Property;
